module.exports = __webpack_public_path__ + "img/dictionary-white.be53dca4.svg";